import React, { useState, useEffect } from 'react';
import { IconButton, MenuItem, Popover, styled } from '@mui/material';
import { AccountCircle } from '@mui/icons-material';
import { getCurrentUserInfo, signOut } from '../../common/auth';
import { useAuth } from "../../common/auth.context";

const PREFIX = 'User';

const classes = {
    actionLink: `${PREFIX}-actionLink`,
    actionLinkIcon: `${PREFIX}-actionLinkIcon`
};

const Root = styled('span')((
    {
        theme
    }
) => ({
    [`& .${classes.actionLink}`]: {
        color: theme.palette.common.white,
        paddingRight: theme.spacing(1),
        paddingLeft: theme.spacing(1)
    },

    [`& .${classes.actionLinkIcon}`]: {
        fontSize: "1.8125rem"
    }
}));

const User = (props) => {

    const { account, logout } = useAuth();

    const [userAnchorEl, setUserAnchorEl] = React.useState(null);

    const handleAccountClick = (event) => {
        setUserAnchorEl(event.currentTarget);
    };

    const handleAccountClose = () => {
        setUserAnchorEl(null);
    };

    const handleLogoutClick = () => {
        setUserAnchorEl(null);
        logout();
    }

    if (props.isAuthenticated) {
        return (
            <Root>
                <IconButton
                    title={account.name}
                    variant="inherit"
                    className={classes.actionLink}
                    aria-controls="user-account-menu"
                    aria-haspopup="true"
                    onClick={handleAccountClick}
                    size="large">
                    <AccountCircle className={classes.actionLinkIcon} />
                </IconButton>
                <Popover
                    id="user-account-menu"
                    anchorEl={userAnchorEl}
                    open={Boolean(userAnchorEl)}
                    onClose={handleAccountClose}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'right',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                    }}
                >
                    <MenuItem onClick={handleAccountClose}>{account.name}</MenuItem>
                    <MenuItem onClick={handleLogoutClick}>Logout</MenuItem>
                </Popover>
            </Root>
        );
    }
    else {
        return (<React.Fragment></React.Fragment>);
    }
}

export default User;